import { type Component, createEffect, type JSX } from "solid-js"
import { useActionLogsSignal } from "../rx/signal/useActionLogsSignal"
import { useEnginePrevStateSignal } from "../rx/signal/useEnginePrevStateSignal"
import { createMutable, modifyMutable, produce, unwrap } from "solid-js/store"
import bindViewCtxToElementV2 from "../lib/bindViewCtxToElementV2"
import bindEngineToComponentV2 from "../lib/canvas/bindEngineToComponentV2"
import createEngineForUI from "../lib/core/engine/createEngineForUI"
import type { Engine } from "../lib/core/engine/Engine.type"
import type { State } from "../lib/core/state/State.type"
import setDuskAttributes from "../lib/dom/setDuskAttribute"
import bindCameraToUserPreferences from "../lib/three/camera/bindCameraToUserPreferences"
import createMainCamera from "../lib/three/fn/createMainCamera"
import createMountedCanvasElement from "../lib/three/fn/createMountedCanvasElement"
import createMountedMainRenderer from "../lib/three/fn/createMountedMainRenderer"
import { setEngineThreeMainCamera } from "../lib/three/fn/getSetEngineThreeMainCamera"
import { setEngineThreeMainRenderer } from "../lib/three/fn/getSetEngineThreeMainRenderer"
import { setEngineStateFromExternal } from "../lib/core/engine/setEngineState"
import createSetEngineAuthPlayerIdFromAuthProfileSignalEffect from "../rx/effect/createSetEngineAuthPlayerIdFromAuthProfileSignalEffect"
import { getAuthProfile } from "../rx/shared/profile/createAuthProfileSignal"

interface Props {
  state: State,
  width: number,
  height: number,
  style?: JSX.CSSProperties,
}

const MapShowCanvas3D: Component<Props> = (props: Props) => {
  // console.log('MapShowCanvas3D', props)

  const engine: Engine = createMutable(createEngineForUI())
  const setActionLogs = useActionLogsSignal(engine)[1]
  const [, setPrevState] = useEnginePrevStateSignal(engine)
  createEffect(() => {
    // console.log('MapShowCanvas3D.props.state', 'updated')
    const newState = unwrap(props.state)
    // console.log('newState', newState)
    modifyMutable(engine, produce(() => {
      setEngineStateFromExternal(engine, newState)
    }))
    setPrevState(newState)
    setActionLogs([])
  })

  // onMount(() => {
  //   syncEngineWithPropsRow(engine, props.state)
  // })

  createSetEngineAuthPlayerIdFromAuthProfileSignalEffect(engine, getAuthProfile)

  const canvasElem = createMountedCanvasElement()
  setDuskAttributes(canvasElem, 'MapShowCanvas3D')
  canvasElem.classList.add('map-show-canvas-3d')
  const renderer = createMountedMainRenderer(canvasElem)
  setEngineThreeMainRenderer(engine, renderer)
  const camera = createMainCamera(canvasElem)
  setEngineThreeMainCamera(engine, camera)

  bindEngineToComponentV2(engine, canvasElem)
  bindViewCtxToElementV2(engine, canvasElem, props)
  bindCameraToUserPreferences(engine)

  // onMountStartCameraNearLastAction(engine)

  // const getGridSize = useGridWidthHeight(engine)
  // // the MapShowCanvas3D camera should be top-down by default
  // setTimeout(() => {
  //   const { width, height } = getGridSize()
  //   const centerOfMap = new Vector3((width * VERTICES_PER_TILE) / 2, 0, (height * VERTICES_PER_TILE) / 2)
  //   centerOfMap.x = 0
  //   camera.position.copy(centerOfMap)
  //   camera.position.y += 2000
  //   // camera.lookAt(centerOfMap)
  //   // camera.updateProjectionMatrix()
  // }, 100)


  return canvasElem
}

export default MapShowCanvas3D
